/**
 * Referrer events composable
 */
export async function useReferrer() {
  const url = useRequestURL()
  const route = useRoute()

  const event_slug = computed(() => route.params.event_slug as string)

  if (!import.meta.server) {
    return {
      referrerData: ref(null),
    }
  }

  const { data: referrerData } =
    await useNuxtApp().$client.referrer.create.useQuery({
      url: url.toString(),
      activityId: event_slug.value,
    })

  return {
    referrerData,
  }
}
